import React, { useEffect, useState } from 'react'
import {
  Box,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useFormik } from 'formik'
import CustomInput from '../../leastcomponent/custominput/input'
import {
  useScheduleTask,
  useGetJobDetailsSingle
} from '../../hooks/jobcardHooks'
import './quantity.css'
import { toast } from 'react-toastify'

const QuantityModal = (props) => {
  const {
    open,
    onClose,
    totalQty,
    isGoBackDashboard,
    jobCard,
    bomPartId,
    deptId,
    setLoadingAfterClose
  } = props
  const [allSelected, setAllSelected] = useState(false)
  const { mutate: addScheduleTask } = useScheduleTask(
    true,
    !!isGoBackDashboard,
    `/job-dep-wise/${jobCard}/${bomPartId}`
  )
  const { data: getJobDetails, error: scheduleError } = useGetJobDetailsSingle(
    jobCard,
    !!jobCard,
    deptId
  )
  const getJobDetailsSchedule = getJobDetails?.data
  const [qtyError, setQtyError] = useState('')
  const selectedPart = getJobDetailsSchedule?.bompart?.find(
    (part) => part.id === bomPartId
  )
  const tasks = selectedPart?.bomprocess
    ?.find((val) => val?.department?.id === deptId)
    ?.task?.map((val) => val?.id)
  const remainingQuantities = selectedPart?.bomprocess?.find(
    (val) => val?.department?.id === deptId
  )?.remainingQty
  const handleQtyChange = (e) => {
    const value = Number(e.target.value)
    if (value > remainingQuantities) {
      setQtyError(`Quantity cannot be greater than ${remainingQuantities}`)
    } else {
      setQtyError('')
    }
    formik.setFieldValue('quantity', value)
  }

  useEffect(() => {
    document.body.className = 'currentapp_hr teams'
    if (scheduleError) {
      console.error('Error fetching job details schedule:', scheduleError)
    } else if (getJobDetailsSchedule && Array.isArray(getJobDetailsSchedule)) {
      console.log('Job details schedule data:', getJobDetailsSchedule)
    }
    const remainingQuantities = getJobDetailsSchedule?.bompart?.map(
      (part) => part.remainingQty
    )
    if (remainingQuantities && remainingQuantities?.some((qty) => qty === 0)) {
      setAllSelected(false)
    }
  }, [getJobDetails, scheduleError, getJobDetailsSchedule])
  const formik = useFormik({
    initialValues: {
      quantity: '',
      id: ''
    },
    onSubmit: (values) => {
      const qtyToSave = allSelected ? remainingQuantities : values.quantity
      const payload = {
        task: tasks?.map((val) => ({
          id: val,
          currentScheduleQty: Number(qtyToSave)
        }))
      }
      setLoadingAfterClose(true)
      onClose()
      addScheduleTask(payload, {
        onSuccess: (res) => {
          setLoadingAfterClose(false)
          toast.success(res?.data?.message)
        },
        onError: (err) => {
          setLoadingAfterClose(false)
          const errorMessage = err?.response?.data?.message
          toast.error(errorMessage)
        }
      })
    }
  })

  const { handleChange, values } = formik
  console.log(handleChange)
  if (!open) return null

  const isSubmitDisabled = () => {
    const remaining = Number(remainingQuantities || 0)
    if (remaining === 0) return true
    if (allSelected) return false
    const qty = Number(values.quantity)
    if (!qty) return true
    if (qty > remaining) return true
    return false
  }

  return (
    <Box className="modal-overlay">
      <Box
        component="form"
        onSubmit={formik.handleSubmit}
        className="modal-box"
      >
        <Box className="modal-header">
          <Typography variant="subtitle1" className="modal-title">
            How much quantity do you want to schedule?
          </Typography>
          <IconButton size="small" onClick={onClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        <Box display="flex" gap={5} alignItems="center">
          <Typography variant="body2" className="modal-total">
            Total quantity - <b>{totalQty}</b>
          </Typography>
          <Typography variant="body2" className="modal-total">
            Remaining quantity - <b>{remainingQuantities}</b>
          </Typography>
        </Box>

        <Box className="modal-input">
          <CustomInput
            label="Quantity for execution"
            placeholder="Enter Quantity"
            handleChange={handleQtyChange}
            value={allSelected ? remainingQuantities : values.quantity}
            name="quantity"
            type="number"
            disabled={allSelected}
          />
        </Box>
        {qtyError && (
          <Typography sx={{ color: 'red', fontSize: 12, marginTop: 1 }}>
            {qtyError}
          </Typography>
        )}
        <FormControlLabel
          control={
            <Checkbox
              checked={allSelected}
              onChange={(e) => setAllSelected(e.target.checked)}
              sx={{ gap: 2 }}
            />
          }
          label="All remaining qty"
          className="checkbox-label"
        />

        <Box className="modal-footer">
          <Button
            variant="contained"
            type="submit"
            className="save-btn-qty"
            disabled={isSubmitDisabled()}
          >
            Schedule
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default QuantityModal
